"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgUpdateTokenPriceOracleResponse = exports.MsgUpdateTokenPriceOracle = exports.MsgSetStaleIndexAllowanceResponse = exports.MsgSetStaleIndexAllowance = exports.MsgSetImpactBandResponse = exports.MsgSetImpactBand = exports.MsgSetSmoothenBandResponse = exports.MsgSetSmoothenBand = exports.MsgSetBackfillTimeIntervalResponse = exports.MsgSetBackfillTimeInterval = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const duration_1 = require("../google/protobuf/duration");
exports.protobufPackage = "Switcheo.carbon.pricing";
const baseMsgSetBackfillTimeInterval = { creator: "" };
exports.MsgSetBackfillTimeInterval = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.backfillTimeInterval !== undefined) {
            duration_1.Duration.encode(message.backfillTimeInterval, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetBackfillTimeInterval);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.backfillTimeInterval = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetBackfillTimeInterval);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.backfillTimeInterval =
            object.backfillTimeInterval !== undefined &&
                object.backfillTimeInterval !== null
                ? duration_1.Duration.fromJSON(object.backfillTimeInterval)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.backfillTimeInterval !== undefined &&
            (obj.backfillTimeInterval = message.backfillTimeInterval
                ? duration_1.Duration.toJSON(message.backfillTimeInterval)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgSetBackfillTimeInterval);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.backfillTimeInterval =
            object.backfillTimeInterval !== undefined &&
                object.backfillTimeInterval !== null
                ? duration_1.Duration.fromPartial(object.backfillTimeInterval)
                : undefined;
        return message;
    },
};
const baseMsgSetBackfillTimeIntervalResponse = {};
exports.MsgSetBackfillTimeIntervalResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetBackfillTimeIntervalResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetBackfillTimeIntervalResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetBackfillTimeIntervalResponse);
        return message;
    },
};
const baseMsgSetSmoothenBand = { creator: "", smoothenBand: 0 };
exports.MsgSetSmoothenBand = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.smoothenBand !== 0) {
            writer.uint32(16).uint32(message.smoothenBand);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetSmoothenBand);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.smoothenBand = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetSmoothenBand);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.smoothenBand =
            object.smoothenBand !== undefined && object.smoothenBand !== null
                ? Number(object.smoothenBand)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.smoothenBand !== undefined &&
            (obj.smoothenBand = message.smoothenBand);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetSmoothenBand);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.smoothenBand = (_b = object.smoothenBand) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
const baseMsgSetSmoothenBandResponse = {};
exports.MsgSetSmoothenBandResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetSmoothenBandResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetSmoothenBandResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetSmoothenBandResponse);
        return message;
    },
};
const baseMsgSetImpactBand = { creator: "", impactBand: 0 };
exports.MsgSetImpactBand = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.impactBand !== 0) {
            writer.uint32(16).uint32(message.impactBand);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetImpactBand);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.impactBand = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetImpactBand);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.impactBand =
            object.impactBand !== undefined && object.impactBand !== null
                ? Number(object.impactBand)
                : 0;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.impactBand !== undefined && (obj.impactBand = message.impactBand);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseMsgSetImpactBand);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.impactBand = (_b = object.impactBand) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
const baseMsgSetImpactBandResponse = {};
exports.MsgSetImpactBandResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetImpactBandResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetImpactBandResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetImpactBandResponse);
        return message;
    },
};
const baseMsgSetStaleIndexAllowance = { creator: "" };
exports.MsgSetStaleIndexAllowance = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.staleIndexAllowance !== undefined) {
            duration_1.Duration.encode(message.staleIndexAllowance, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetStaleIndexAllowance);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.staleIndexAllowance = duration_1.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgSetStaleIndexAllowance);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.staleIndexAllowance =
            object.staleIndexAllowance !== undefined &&
                object.staleIndexAllowance !== null
                ? duration_1.Duration.fromJSON(object.staleIndexAllowance)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.staleIndexAllowance !== undefined &&
            (obj.staleIndexAllowance = message.staleIndexAllowance
                ? duration_1.Duration.toJSON(message.staleIndexAllowance)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseMsgSetStaleIndexAllowance);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.staleIndexAllowance =
            object.staleIndexAllowance !== undefined &&
                object.staleIndexAllowance !== null
                ? duration_1.Duration.fromPartial(object.staleIndexAllowance)
                : undefined;
        return message;
    },
};
const baseMsgSetStaleIndexAllowanceResponse = {};
exports.MsgSetStaleIndexAllowanceResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgSetStaleIndexAllowanceResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgSetStaleIndexAllowanceResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgSetStaleIndexAllowanceResponse);
        return message;
    },
};
const baseMsgUpdateTokenPriceOracle = {
    creator: "",
    denom: "",
    oracleId: "",
};
exports.MsgUpdateTokenPriceOracle = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.oracleId !== "") {
            writer.uint32(26).string(message.oracleId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateTokenPriceOracle);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.oracleId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseMsgUpdateTokenPriceOracle);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.oracleId =
            object.oracleId !== undefined && object.oracleId !== null
                ? String(object.oracleId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.denom !== undefined && (obj.denom = message.denom);
        message.oracleId !== undefined && (obj.oracleId = message.oracleId);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseMsgUpdateTokenPriceOracle);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.oracleId = (_c = object.oracleId) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseMsgUpdateTokenPriceOracleResponse = {};
exports.MsgUpdateTokenPriceOracleResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseMsgUpdateTokenPriceOracleResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseMsgUpdateTokenPriceOracleResponse);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseMsgUpdateTokenPriceOracleResponse);
        return message;
    },
};
class MsgClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.SetBackfillTimeInterval = this.SetBackfillTimeInterval.bind(this);
        this.SetSmoothenBand = this.SetSmoothenBand.bind(this);
        this.SetImpactBand = this.SetImpactBand.bind(this);
        this.SetStaleIndexAllowance = this.SetStaleIndexAllowance.bind(this);
        this.UpdateTokenPriceOracle = this.UpdateTokenPriceOracle.bind(this);
    }
    SetBackfillTimeInterval(request) {
        const data = exports.MsgSetBackfillTimeInterval.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.pricing.Msg", "SetBackfillTimeInterval", data);
        return promise.then((data) => exports.MsgSetBackfillTimeIntervalResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetSmoothenBand(request) {
        const data = exports.MsgSetSmoothenBand.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.pricing.Msg", "SetSmoothenBand", data);
        return promise.then((data) => exports.MsgSetSmoothenBandResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetImpactBand(request) {
        const data = exports.MsgSetImpactBand.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.pricing.Msg", "SetImpactBand", data);
        return promise.then((data) => exports.MsgSetImpactBandResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetStaleIndexAllowance(request) {
        const data = exports.MsgSetStaleIndexAllowance.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.pricing.Msg", "SetStaleIndexAllowance", data);
        return promise.then((data) => exports.MsgSetStaleIndexAllowanceResponse.decode(new minimal_1.default.Reader(data)));
    }
    UpdateTokenPriceOracle(request) {
        const data = exports.MsgUpdateTokenPriceOracle.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.pricing.Msg", "UpdateTokenPriceOracle", data);
        return promise.then((data) => exports.MsgUpdateTokenPriceOracleResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgClientImpl = MsgClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
